/* PANDI Popup Mobile Fix v1 (2026-06-01)
 * Hardens the newsletter popup so the X is always reachable on mobile.
 * - Re-parents .popup-close from .popup-content to .popup-outer so absolute
 *   positioning puts it at top-right of the whole popup (over the image area).
 * - Adds role="dialog" + aria-modal for screen readers.
 * - Re-runs on Shopify section load and on dynamic DOM insertion.
 * Reversible: delete this asset + remove the <script> in layout/theme.liquid. */
(function () {
  'use strict';

  function fixPopup(popup) {
    if (!popup || popup.dataset.pandiPopupFixed === '1') return;
    var outer = popup.querySelector('.popup-outer');
    var closeBtn = popup.querySelector('.popup-close, .modal-close-button');
    if (outer && closeBtn && closeBtn.parentElement !== outer) {
      outer.appendChild(closeBtn);
    }
    popup.dataset.pandiPopupFixed = '1';
    if (!popup.getAttribute('role')) popup.setAttribute('role', 'dialog');
    if (!popup.getAttribute('aria-modal')) popup.setAttribute('aria-modal', 'true');
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.popup-main').forEach(fixPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  // Watch for popups injected after the initial render
  if (window.MutationObserver) {
    var mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (!m.addedNodes) return;
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('.popup-main')) fixPopup(n);
          if (n.querySelectorAll) initAll(n);
        });
      });
    });
    function start() { if (document.body) mo.observe(document.body, { childList: true, subtree: true }); }
    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start);
  }
})();
